import { NFormTable } from "src/components/Shared/NewForms/NFormTable";
import { NFPlainNumber } from "src/components/Shared/NewForms/NFPlainNumber";
import { NFLookupBaseDocuments } from "src/components/Shared/NewForms/NFLookupBaseDocuments";
import { NFLookupCurrency } from "src/components/Shared/NewForms/NFlookupCurrency";
import { NFLookupCashflowItem } from "src/components/Shared/NewForms/NFLookupCashflowItem";
import { NFIntInput } from "src/components/Shared/NewForms/NFIntInput";
import { useTranslation } from "react-i18next";

const ExpenseBanksDetailPayments = () => {
  const { t } = useTranslation();
  return (
    <>
      <NFormTable fieldArray={"payments"}>
        <NFPlainNumber fieldName={"lineNo"} title={t("#")} width={50} />
        <NFLookupBaseDocuments title={t("ArApDocument")} fieldName="arApDocument" />
        <NFLookupCurrency title={t("Currency")} fieldName="currencyId" width={200} />
        <NFLookupCashflowItem title={t("cashFlowItemId")} fieldName="cashFlowItemId" width={200} />
        <NFIntInput title={t("Amount")} fieldName="amount" />
        <NFIntInput title={t("CurrencyRate")} fieldName="currencyRate" />
        <NFIntInput title={t("CurrencyQuantity")} fieldName="currencyQuantity" width={150} />
        <NFIntInput title={t("CurrencyAmount")} fieldName="currencyAmount" />
      </NFormTable>
    </>
  );
};

export default ExpenseBanksDetailPayments;
